export default __webpack_public_path__ + "images/logo.png?a548efe598d430a12c36d4b30a3c5416";